import { FC } from "react";

import { QuoteRecord } from "@graphql/types/graphql";

import { Caption } from "components/atoms/Caption/Caption";
import { IResponsiveImage } from "@types";

import classNames from "classnames";
import { StructuredText } from "components/sections/RichtextSection/StructuredText";
import s from "./Quote.module.scss";

interface Props {
  data: QuoteRecord;
}

export const Quote: FC<Props> = ({ data: { text, author, authorImage, authorFunction } }) => (
  <figure className={s.Quote}>
    <blockquote className={classNames(s.QuoteTitle, "prose")}>
      <StructuredText structuredText={text as any} />
    </blockquote>
    {(author || authorFunction) && (
      <Caption
        image={authorImage as IResponsiveImage}
        author={author ?? undefined}
        authorFunction={authorFunction ?? undefined}
      />
    )}
  </figure>
);
